/**
 * Slick Hero Slider
 */
jQuery(function() {
    $('.hero-slider').slick({
        useTransform: false,
        autoplay: true,
        autoplaySpeed: 5000
    });

});

/**
 * Product Carousel
 */
jQuery(function() {

    $productThumbnailSlider = $('.product-detail-photo-thumbnails');
    $productThumbnailSlider.slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3
    });
    $productThumbnailSlider.show();

    $('.product-carousel-thumbnail').on('click', function(){
        if(!$(this).hasClass('active')){
            $('.product-carousel-thumbnail').removeClass('active');
            $(this).addClass('active');
            $('#product-full-image').prop('src', $(this).data('full'));
        }
    });

});

/**
 **	Sets embedded Youtube video aspect ratios based on the iframe's parent container
 **/
jQuery(function() {
    // Find all YouTube videos
    var $allVideos = $("iframe[src*='youtube.com']");

    // Figure out and save aspect ratio for each video
    $allVideos.each(function() {

        $(this)
            .data('aspectRatio', this.height / this.width)

            // and remove the hard coded width/height
            .removeAttr('height')
            .removeAttr('width');

    });

    // When the window is resized
    $(window).resize(function() {

        // Resize all videos according to their own aspect ratio
        $allVideos.each(function() {

            var newWidth = $(this).parent().width();

            var $el = $(this);
            $el
                .width(newWidth)
                .height(newWidth * $el.data('aspectRatio'));

        });

        // Kick off one resize to fix all videos on page load
    }).resize();

    $('.collapse').on('shown.bs.collapse', function(){
        $(window).resize();
    });

    $('a[data-toggle="tab"]').on('shown.bs.tab', function(){
        $(window).resize();
    });
});


/**
 * Address Toggle
 */
jQuery(function() {

    $('#changeAddressBtn').on('click', function(){
        $('#billingAddressDiv').addClass('d-none');
        $('#selectAddressDiv').removeClass('d-none');
    });

    $('.select-address-btn').on('click', function(){
        var $address_container = $(this).parent().parent();
        var full_address = $address_container.find('.full_address').val();
        var address_id = $address_container.find('.address_id').val();

        $('#display_formatted_address').html(full_address);

        $('#address_id').val(address_id);

        $('#selectAddressDiv').addClass('d-none');
        $('#billingAddressDiv').removeClass('d-none');
    });

    if($('.address-container').length === 0){
        $('#billingAddressDiv').addClass('d-none');
        $('#selectAddressDiv').removeClass('d-none');
    }

});

/**
 * Item Detail License Addon Toggle
 */
jQuery(function() {

    $('.license-radio-button').on('click', function(){
       $parentRow =  $(this).parents('tr');
       $parentTable = $parentRow.parents('table');
       $parentTable.find('tr').removeClass('active');

       $('.switch').prop("checked", false);

       $parentRow.addClass('active');

       $parentRow.nextUntil('.license').addClass('active');

    });

});

/**
 * Cancel Subscription Confirmation
 */
jQuery(function() {

    $('#cancelSubscription').on("submit", function(){
        return confirm("Are You Sure You Want To Cancel This Subscription?");
    });

});

/**
 * Mange Software Updates Selection
 */
jQuery(function() {

    $('#updateSelectionTable input[name="updateType"]').on('click', function(){
        $('#stripePaymentForm input[name="type"]').val($(this).val());
    });

});


/**
 * Stripe Elements
 */
jQuery(function() {

    if(typeof Stripe !== 'undefined') {
        var stripe = Stripe(document.querySelector('meta[name="stripe-pkey"]').content);
        var elements = stripe.elements();

        var elementStyles = {
            base: {
                color: '#32325D',
                fontWeight: 500,
                fontFamily: 'Source Code Pro, Consolas, Menlo, monospace',
                fontSize: '16px',
                fontSmoothing: 'antialiased',

                '::placeholder': {
                    color: '#CFD7DF',
                },
                ':-webkit-autofill': {
                    color: '#e39f48',
                },
            },
            invalid: {
                color: '#E25950',

                '::placeholder': {
                    color: '#FFCCA5',
                },
            },
        };

        var elementClasses = {
            base: 'input-field form-control',
            focus: 'focused',
            empty: 'empty',
            invalid: 'invalid',
        };

        if ($("#card-number").length && $("#card-expiration").length && $("#card-security").length) {
            var cardNumber = elements.create('cardNumber', {
                style: elementStyles,
                classes: elementClasses,
            });
            cardNumber.mount('#card-number');

            var cardExpiry = elements.create('cardExpiry', {
                style: elementStyles,
                classes: elementClasses,
            });
            cardExpiry.mount('#card-expiration');

            var cardCvc = elements.create('cardCvc', {
                style: elementStyles,
                classes: elementClasses,
            });
            cardCvc.mount('#card-security');

            cardNumber.addEventListener('change', function (event) {
                if (event.error) {
                    $('#card-number-errors').text(event.error.message);
                } else {
                    $('#card-number-errors').text('');
                }
            });

            cardExpiry.addEventListener('change', function (event) {
                if (event.error) {
                    $('#card-expiration-errors').text(event.error.message);
                } else {
                    $('#card-expiration-errors').text('');
                }
            });

            cardCvc.addEventListener('change', function (event) {
                if (event.error) {
                    $('#card-security-errors').text(event.error.message);
                } else {
                    $('#card-security-errors').text('');
                }
            });

            $('body').on('click', '#submitStripePayment', function () {
                $(this).prop("disabled", "disabled");

                stripe.createSource(cardNumber).then(function (result) {
                    if (result.error) {
                        // Inform the customer that there was an error.
                        var errorElement = document.getElementById('card-errors');
                        errorElement.textContent = result.error.message;
                        $('#submitStripePayment').prop("disabled", false);
                    } else {
                        // Send the token to your server.
                        stripeTokenHandler(result.source);
                    }
                });
            });

            $('#addStripePayment').on('click', function () {
                $(this).prop("disabled", "disabled");

                stripe.createSource(cardNumber).then(function (result) {
                    if (result.error) {
                        $('#addStripePayment').prop("disabled", false);
                    } else {
                        // Send the token to your server.
                        addStripePayment(result.source);
                    }
                });
            });

            $('#purchaseLicenseUpdateForm').on('submit', function (event) {
                $('#submitUpdatePayment').prop("disabled", "disabled");

                $sourceType = $("input[name='source-type']:checked").val();
                $source = $("input[name='source']:checked").val();

                if($sourceType === "select-source" && typeof $source !== "undefined" ) {
                    return;
                } else if($sourceType === "new-card") {
                    if($('#newSource').val() !== '') {
                        return;
                    }

                    event.preventDefault();
                    stripe.createSource(cardNumber).then(function (result) {
                        if (result.error) {
                            // Inform the customer that there was an error.
                            var errorElement = document.getElementById('card-errors');
                            errorElement.textContent = result.error.message;
                            $('#submitUpdatePayment').prop("disabled", false);
                        } else {
                            $('#newSource').val(result.source.id);
                            $('#purchaseLicenseUpdateForm').submit();
                        }
                    });
                } else {
                    event.preventDefault();
                    console.log('Invalid Type Selected');
                }
            });

        } else {
            $('body').on('click', '#submitStripePayment', function () {
                $(this).prop("disabled", "disabled");

                stripeTokenHandler(null);
            });
        }

        function stripeTokenHandler(token) {
            var form = $('#stripePaymentForm');
            var stripeToken = $("#stripeToken");
            var address_line_1 = $("#addAddressLine1");
            var address_line_2 = $("#addAddressLine2");
            var city = $("#addCity");
            var state = $("#addState");
            var postal_code = $("#addPostalCode");
            var country = $("#addCountry");

            if(token !== null) {
                stripeToken.val(token.id);
            }

            address_line_1.val($('#address_line_1').val());
            address_line_2.val($('#address_line_2').val());
            city.val($('#city').val());
            state.val($('#state').val());
            postal_code.val($('#postal_code').val());
            country.val($('#country').val());

            // Submit the form
            form.submit();
        }

        function addStripePayment(token) {
            var stripeToken = $("#stripeToken");

            if(token !== null) {
                stripeToken.val(token.id);
            }

            // Submit the form
            $('#stripeAddPaymentForm').submit();
        }
    }
});

/**
 * Product Read More Functionality
 */
jQuery(function() {

    function setStateProvinceSelector() {
        let $selectState = $("#billing-address-wrapper select[name='state']");
        let $textState = $("#billing-address-wrapper input[name='state']");
        let $matchingStates = $("#billing-address-wrapper select[name='state'] > option[data-country='" + $('#country').val() +"']");

        $("select[name='state'] > option").prop('hidden', true).prop('disabled', true);

        $matchingStates.prop('hidden', false).prop('disabled', false);

        if($matchingStates.length > 0) {
            $selectState.prop('id', 'state_temp');
            $textState.prop('id', 'state_other').prop('disabled', true).addClass('d-none');
            $selectState.prop('id', 'state').prop('disabled', false).removeClass('d-none');
        } else {
            $textState.prop('id', 'state_temp')
            $selectState.prop('id', 'state_other').prop('disabled', true).addClass('d-none');
            $textState.prop('id', 'state').prop('disabled', false).removeClass('d-none');
        }

    }

    $('body').on('change', '#country', setStateProvinceSelector);

    setStateProvinceSelector();
});

/**
 * Product Read More Functionality
 */
jQuery(function() {

    $('.readMoreButton').on('click', function(){
        $parent = $(this).parent();

        $(this).removeClass('d-block').addClass('d-none');
        $parent.find('.read-more').removeClass('d-none');
        $parent.find('.readLessButton').removeClass('d-none').addClass('d-block');
    });

    $('.readLessButton').on('click', function(){
        $parent = $(this).parent();

        $(this).removeClass('d-block').addClass('d-none');
        $parent.find('.read-more').addClass('d-none');
        $parent.find('.readMoreButton').removeClass('d-none').addClass('d-block');
    });

});

/**
 * Cart Quantity Update
 */
jQuery(function() {

    $('body').on('change', '.cart-quantity-input', function(){
        $(this).parent().submit();
    });

});

/**
 * Show Calculated Tax
 */
jQuery(function() {
    $('body').on('change', '#address_line_1, #address_line_2, #city, #state, #postal_code, #country', function() {
        updateCartTable();
    });

    function updateCartTable() {

        if(
            $('#address_line_1').val() === '' ||
            $('#city').val() === '' ||
            $('#postal_code').val() === '' ||
            $('#country').val() === ''
        ) {
            return false;
        }

        $('#submitStripePayment').prop('disabled', 'disabled');

        $.ajax({
            type: 'post',
            url : "/get-updated-cart",
            data: {
                address_line_1: $('#address_line_1').val(),
                address_line_2: $('#address_line_2').val(),
                city: $('#city').val(),
                state: $('#state').val(),
                postal_code: $('#postal_code').val(),
                country: $('#country').val(),
                '_token': $('meta[name="csrf-token"]').attr('content')
            },
            dataType: "json",
            success : function (data) {
                if(typeof data.success === 'undefined' || !data.success) {
                    return false;
                }
                $('div.cart-panel').replaceWith(data.view);
                $('#submitStripePayment').prop('disabled', false);
            },
            error: function(data) {
                $.each(data.responseJSON.errors, function(key) {
                    $('#' + key).addClass('is-invalid');
                });
            }
        });
    }
});

/**
 * Make Product Description Tabs Responsive
 */
jQuery(function() {

    $tables = $('.product-tabs').find('table')

    $tables.parent().addClass('table-responsive');

    $tables.find('td').addClass('d-sm-block d-md-table-cell col-12')

});

/**
 * Load Paginated Account Licenses Via AJAX
 */
jQuery(function() {

    $('body').on('click', '.product-platform-paginate-btn', function(){
        updateProductPlatform($(this).parents('.account-license').first(), $(this).parent().serialize());
    });

    $.fn.replaceWithPush = function(a) {
        var $a = $(a);

        this.replaceWith($a);
        return $a;
    };

    function updateProductPlatform($element, $data){
        $element.find('input').attr('disabled', 'disabled');

        $.ajax({
            type: 'post',
            url : "/account/licenses/get-paginated-licenses",
            data: $data,
            dataType: "html",
            context: $element,
            success : function (data) {
                $element = $(this).replaceWithPush(data);
            },
            error : function(data) {
                $element.remove();
            }
        });
    }
});

/**
 * Bootstrap 4 Multiple File Upload Text Fix
 */
jQuery(function() {

    $('input.multiple-file-upload').change(function (e) {
        var files = [];
        if($(this)[0].files.length === 1){
            for (var i = 0; i < $(this)[0].files.length; i++) {
                files.push($(this)[0].files[i].name);
            }
            $(this).next('.custom-file-label').html(files.join(', '));
        } else {
            $(this).next('.custom-file-label').html($(this)[0].files.length + ' Files Seclected');
        }
    });

});

(function () {
    var passwordHelp = document.querySelector('#password_help');

    if (passwordHelp) {
        function showPasswordHelp() {
            passwordHelp.style.display = 'block';
            passwordHelp.style.visibility = 'visible';
        }

        function hidePasswordHelp() {
            passwordHelp.style.display = 'none';
            passwordHelp.style.visibility = 'hidden';
        }

        Array.from(document.querySelectorAll('#password, #password_confirmation')).forEach(function (element) {
            element.addEventListener('focusin', showPasswordHelp);
            element.addEventListener('focusout', function (event) {
                if (passwordValid() || !event.target.value) {
                    hidePasswordHelp();
                } else {
                    showPasswordHelp();
                }
            });
        });

        function passwordValid() {
            var regex = RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).+$/);

            return regex.test(document.querySelector('#password').value);
        }
    }
})();

/**
 * Stop License Update Page Accordions From Closing Themselves
 */
jQuery(function() {
    $('#license-update-accordion [data-toggle="collapse"]').on('click',function(e){
        if ( $(this).parents('.accordion').find('.collapse.show') ){
            var idx = $(this).index('[data-toggle="collapse"]');
            if (idx == $('.collapse.show').index('.collapse')) {
                e.stopPropagation();
            }
        }
    });
});

/**
 * Buy Now Button
 */
jQuery(function() {

    $('.buy-now-button').on('click', function() {
        let $form = $(this).parents('form');
        $form.attr('action', $(this).data('endpoint'));
        $form.submit();
    });

});
